import { render, staticRenderFns } from "./PostulacionBusqueda.vue?vue&type=template&id=066621a9&scoped=true&"
import script from "./PostulacionBusqueda.vue?vue&type=script&lang=js&"
export * from "./PostulacionBusqueda.vue?vue&type=script&lang=js&"
import style0 from "./PostulacionBusqueda.vue?vue&type=style&index=0&id=066621a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066621a9",
  null
  
)

export default component.exports